import { render, staticRenderFns } from "./CustomFile.vue?vue&type=template&id=e4dc8bd8&"
import script from "./CustomFile.vue?vue&type=script&lang=js&"
export * from "./CustomFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports